import axios from 'axios';
import Qs from 'qs';
import { toast } from 'react-toastify';
import { emitter } from 'use-event-listeners';

const { VITE_APP_API_URL } = import.meta.env;

export const baseUrl = VITE_APP_API_URL;
const api = axios.create({ baseURL: baseUrl });
let logoutNavigationRequested = false;
let authRefreshHandler = null;
let refreshInFlight = null;

export const setAuthRefreshHandler = (handler) => {
  authRefreshHandler = handler;
};

export const refreshAuthToken = () => {
  if (!authRefreshHandler) return Promise.resolve(null);
  if (!refreshInFlight) {
    refreshInFlight = Promise.resolve()
      .then(() => authRefreshHandler())
      .finally(() => {
        refreshInFlight = null;
      });
  }
  return refreshInFlight;
};

api.interceptors.request.use(
  (config) => {
    config.paramsSerializer = (params) =>
      Qs.stringify(params, {
        arrayFormat: 'brackets',
        encode: false
      });

    return config;
  },
  (err) => {
    console.log('interceptors request err: ', err);
  }
);

api.interceptors.response.use(
  (response) => {
    if (window.location.pathname === '/auth/login') {
      logoutNavigationRequested = false;
    }
    return response;
  },
  (err) => {
    if (err?.response?.status === 401 && window.location.pathname !== '/auth/login') {
      if (!logoutNavigationRequested) {
        logoutNavigationRequested = true;
        emitter.emit('log-out-navigation');
      }
    } else if (err?.response?.status === 403) {
      toast.error(err.response.data.message);
    } else if (err?.response?.status === 429) {
      toast.error(err.response.data.message || 'Rate limit exceeded, please try again later');
    }
    return Promise.reject(err);
  }
);

export default api;
